import { graphql } from '@teachino/shared-infrastructure';

export const duplicateItemsMutation = graphql(`
  mutation DuplicateItems($duplicateItemsInput: DuplicateItemsInput!) {
    duplicateItems(duplicateItemsInput: $duplicateItemsInput) {
      id
      name
    }
  }
`);
